import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      d="M16 7c-3.565 0-5.613 2.014-5.613 4v.012c-.002.232.032.463.103.683a1 1 0 1 1-1.905.61 4.2 4.2 0 0 1-.198-1.31C8.391 7.457 11.842 5 16 5c3.238 0 5.974 1.448 7.088 3.752a1 1 0 1 1-1.801.87C20.601 8.203 18.712 7 16 7M4 16a1 1 0 0 1 1-1h22a1 1 0 1 1 0 2h-5.009c1.192.917 2.009 2.202 2.009 4 0 1.788-1.017 3.312-2.47 4.35C20.074 26.389 18.115 27 16 27s-4.074-.611-5.53-1.65C9.018 24.312 8 22.788 8 21a1 1 0 1 1 2 0c0 .974.552 1.95 1.633 2.722C12.712 24.492 14.253 25 16 25s3.288-.508 4.367-1.278C21.448 22.95 22 21.974 22 21c0-1.114-.476-1.866-1.316-2.48-.869-.637-2.093-1.096-3.528-1.52H5a1 1 0 0 1-1-1"
    />
  </svg>
);
const SvgIconTextStrikethrough = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconTextStrikethrough);
export default Memo;
